<template>
  <div class="h-auto ml-0 w-full lg:mr-3 mt-2 p-3 pt-0">
    <el-tabs v-model="selectedSubMenu" @tab-click="handleTabClick" type="border-card">
      <el-tab-pane
          v-for="(menu, index) in subMenus"
          :key="index"
          :label="menu.name"
          :name="menu.name"
          :class="{
            'bg-primary text-white': selectedSubMenu === menu.name,
          }"
      >

      </el-tab-pane>
      <component :is="currentComponent" :key="currentTabKey"></component>
    </el-tabs>

    <!-- Dynamically load the component based on the selected tab -->

  </div>
</template>

<script>
// Organization/Core setups
import DepartmentsList from '@/components/CompanySetups/departments/departmentsList.vue';
import LocationList from '@/components/CompanySetups/locations/locationsList.vue';
import JobTitleList from '@/components/CompanySetups/jobTitles/jobTitlesList.vue';
import EmploymentTypeList from '@/components/CompanySetups/employmentTypes/employmentTypeList.vue';
import JobGradeAndBenefits from '@/components/CompanySetups/jobGrades/jobGradeList.vue';
import BranchesList from '@/components/CompanySetups/branches/branchesList.vue';
import EmploymentStatusList from '@/components/CompanySetups/employmentStatus/employmentStatusList.vue';
import SeparationTypeList from '@/components/CompanySetups/separation/separationTypeList.vue';
import { mapGetters } from 'vuex';
import DisciplinaryTypesList from "@/components/CompanySetups/disciplinary/disciplinaryTypesList";

export default {
  name: 'CompanySetups',
  components: {
    DepartmentsList,
    LocationList,
    JobTitleList,
    EmploymentTypeList,
    JobGradeAndBenefits,
    BranchesList,
    EmploymentStatusList,
    SeparationTypeList,
    DisciplinaryTypesList
  },
  data() {
    return {
      selectedSubMenu: '', // Holds the current selected tab
      subMenus: [
        { name: 'Companies', route: 'locations', component: LocationList },
        { name: 'Branches', route: 'branches', component: BranchesList },
        { name: 'Job Titles', route: 'jobtitles', component: JobTitleList },
        {
          name: 'Departments',
          route: 'department',
          component: DepartmentsList,
        },
        {
          name: 'Employment Type',
          route: 'employmenttypes',
          component: EmploymentTypeList,
        },
        {
          name: 'Job Grade',
          route: 'jobgradeandbenefits',
          component: JobGradeAndBenefits,
        },
        {
          name: 'Employment Status',
          route: 'employmentstatus',
          component: EmploymentStatusList,
        },
        {
          name: 'Separation',
          route: 'separationtypes',
          component: SeparationTypeList,
        },
        {
          name: 'Disciplinary',
          route: 'disciplinarytypes',
          component: DisciplinaryTypesList,
        }
      ],
      currentTabKey: 0, // Helps in forcing re-render when tab changes
    };
  },
  computed: {
    ...mapGetters(['getOrganization']),
    // Dynamically resolve the component based on selectedSubMenu
    currentComponent() {
      const menu = this.subMenus.find(
          (menu) => menu.name === this.selectedSubMenu
      );
      return menu ? menu.component : null;
    },
  },
  methods: {
    // Handle tab click and programmatically change the route
    handleTabClick(tab) {
      const menu = this.subMenus.find((menu) => menu.name === tab.name);
      if (menu) {
        this.$router.push({
          name: 'core-setups',
          params: { type: menu.route, company: this.getOrganization },
        });
      }
    },
  },
  watch: {
    $route(to) {
      const menu = this.subMenus.find((menu) => menu.route === to.params.type);
      if (menu) {
        this.selectedSubMenu = menu.name;
        this.currentTabKey++; // Force re-render to avoid caching issues
      }
    },
  },
  created() {
    const currentRoute = this.$route.params.type;
    const menu = this.subMenus.find((menu) => menu.route === currentRoute);
    if (menu) {
      this.selectedSubMenu = menu.name;
    } else {
      this.selectedSubMenu = this.subMenus[0].name; // Default to the first tab
    }
  },
};
</script>

<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
</style>
